// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"990a2873","249":"a74250c5","396":"e0240847","655":"493e975e","831":"1ab88520","981":"2e77f74e"}[chunkId] + ".chunk.css";
};